// src/components/ListingsGrid.js

import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import ListingCard from './ListingCard';

const ListingsGrid = ({ listings, wishlistedItems, onWishlistUpdate, dateRange }) => {
    if (listings.length === 0) {
        return (
            <Box mt={5} display="flex" justifyContent="center">
                <Typography variant="h6">No listings found.</Typography>
            </Box>
        );
    }

    return (
        <Grid container spacing={3}>
            {listings.map((listing) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={listing.id}>
                    <ListingCard
                        listing={listing}
                        isWishlisted={wishlistedItems.has(listing.id)}
                        onWishlistUpdate={onWishlistUpdate}
                        dateRange={dateRange}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

ListingsGrid.propTypes = {
    listings: PropTypes.array.isRequired,
    wishlistedItems: PropTypes.instanceOf(Set).isRequired,
    onWishlistUpdate: PropTypes.func.isRequired,
};
export default ListingsGrid;
